export const IconStroke = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="2"
            height="15"
            viewBox="0 0 2 15"
            fill="none"
        >
            <path d="M1 1V14" stroke="#E1E1E1" stroke-linecap="round" />
        </svg>
    );
};
